import { render, staticRenderFns } from "./ModalAlertDate.vue?vue&type=template&id=38b3255a&scoped=true&"
import script from "./ModalAlertDate.vue?vue&type=script&lang=js&"
export * from "./ModalAlertDate.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertDate.vue?vue&type=style&index=0&id=38b3255a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b3255a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog,VDivider})
